import { useQueryParams } from 'hooks/useQueryParams';
import { SEARCH_DRAWER_TAB_PARAM_KEY } from 'components/IncidentsMap/SearchDrawer/SearchDrawer.constants';
import { useSearchDrawerTabs } from 'components/IncidentsMap/SearchDrawer/hooks/useSearchDrawerTabs';
import { useSearchDrawerState } from 'state/useSearchDrawerState';

export const usePhotoModerationTabActive = (): boolean => {
  const showPhotosTab = useSearchDrawerTabs();
  const { open: isSearchDrawerOpen } = useSearchDrawerState();
  const [{ [SEARCH_DRAWER_TAB_PARAM_KEY]: activeTab }] = useQueryParams<{
    [SEARCH_DRAWER_TAB_PARAM_KEY]: string | null;
  }>();

  return isSearchDrawerOpen && showPhotosTab && activeTab === 'photoModeration';
};
